import { createContext, useContext, useEffect, useState } from "react";
import { retablirAccentMemorise } from "@/utils/accentTenant";

const ThemeContext = createContext({ theme: "dark", setTheme: () => {} });

export function ThemeProvider({ children }) {
  // Rétablit l'accent du tenant avant le 1er rendu (pas de flash bleu au rechargement).
  useState(retablirAccentMemorise);

  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("omnihub-theme") || "dark";
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("light", "dark");
    root.classList.add(theme);
    localStorage.setItem("omnihub-theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
